module.exports = __webpack_public_path__ + "static/media/carret_left.967259ba.svg";